import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';
import { GoogleRatingCard } from './google-rating.card';

/* eslint-disable-next-line */
export interface GoogleRestworldRatingUIProps {
  rating: number;
  userRatingsTotal: number;
}

export function GoogleRestworldRatingUI({ userRatingsTotal, rating }: GoogleRestworldRatingUIProps) {
  const { t } = useTranslation();
  return userRatingsTotal ? (
    <div className="flex flex-col gap-4">
      <Heading size={4} weight="semibold" color="primary" align="center">
        {t('common:people_trust_us')}
      </Heading>
      <GoogleRatingCard
        {...{ rating, description: `(${t('common:based_on')} ${userRatingsTotal} ${t('common:reviews')})` }}
      />
    </div>
  ) : null;
}

export * from './google-rating.card';

export default GoogleRestworldRatingUI;
